(() => {
  if (window.vextorV2Initialized) return;
  window.vextorV2Initialized = true;
  const init = (root = document) => {
    root.querySelectorAll('[data-vx-product]').forEach((panel) => {
      if (panel.dataset.ready) return;
      panel.dataset.ready = 'true';
      const main = panel.querySelector('.vx-gallery__image');
      const lightbox = panel.querySelector('.vx-lightbox');
      panel.querySelectorAll('[data-vx-thumb]').forEach((thumb) => thumb.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = thumb.dataset.vxThumb;
        main.alt = thumb.getAttribute('aria-label');
        panel.querySelectorAll('[data-vx-thumb]').forEach((t) => t.classList.toggle('is-active', t === thumb));
        if (lightbox) lightbox.querySelector('img').src = thumb.dataset.vxThumb;
      }));
      panel.querySelector('[data-vx-zoom]')?.addEventListener('click', () => lightbox?.showModal());
      panel.querySelectorAll('.vx-pack input').forEach((input) => input.addEventListener('change', () => {
        panel.querySelectorAll('.vx-pack').forEach((label) => label.classList.toggle('is-selected', label.contains(input)));
        panel.querySelectorAll('[data-vx-price]').forEach((label) => label.textContent = input.dataset.price);
        const available = input.dataset.available === 'true';
        const add = panel.querySelector('.vx-add');
        add.disabled = !available;
        panel.querySelector('[data-vx-add-label]').textContent = available ? panel.dataset.addLabel : panel.dataset.soldLabel;
        const url = new URL(location.href);url.searchParams.set('variant', input.value);history.replaceState({}, '', url);
      }));
      const sticky = document.querySelector('[data-vx-sticky]');
      if (sticky) new IntersectionObserver(([entry]) => { sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, {threshold:0}).observe(panel);
    });
    root.querySelectorAll('[data-vx-range]').forEach((range) => {
      if (range.dataset.ready) return;range.dataset.ready = 'true';
      range.addEventListener('input', () => {range.closest('[data-vx-compare]').style.setProperty('--vx-position', `${range.value}%`);range.setAttribute('aria-valuetext', `${range.value}%`);});
    });
  };
  document.addEventListener('click', (event) => {
    const opener=event.target.closest('[data-vx-open]');
    if(opener) document.getElementById(opener.dataset.vxOpen)?.showModal();
    const closer=event.target.closest('[data-vx-close]');if(closer) closer.closest('dialog')?.close();
    if(event.target instanceof HTMLDialogElement){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
  });
  document.addEventListener('change',(event)=>{if(event.target.matches('[data-vx-country]'))event.target.closest('form').requestSubmit();});
  document.addEventListener('shopify:section:load', (event)=>init(event.target));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
})();